import { ActionTree, ActionContext } from "vuex";

import { RootState } from "@/store/root-state";
import type { Auth } from "@/models/auth";
import { Mutations } from "./mutations";

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(key: K, payload: Parameters<Mutations[K]>[1]): ReturnType<Mutations[K]>;
} & Omit<ActionContext<Auth, RootState>, "commit">;

export interface Actions {
  SetTimeout({ commit }: AugmentedActionContext, timeout: string): void;
  SetLogin({ commit }: AugmentedActionContext, login: string): void;
  SetToken({ commit }: AugmentedActionContext, token: string): void;
  //Login({ commit }: AugmentedActionContext, login: string, password: string): void;
}

export const actions: ActionTree<Auth, RootState> & Actions = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  SetTimeout({ commit }, timeout: string) {
    commit("SET_TIMEOUT", timeout);
  },
  SetLogin({ commit }, login: string) {
    commit("SET_LOGIN", login);
  },
  SetToken({ commit }, token: string) {
    commit("SET_TOKEN", token);
  },
  /*Login({ commit }, login: string, password: string) {
    this.$auth.login({
      data: {
        username: "admin@genvue.com",
        password: "123PassWord.!",
        grant_type: "password",
        scope: "openid email profile offline_access",
      },
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      redirect: sessionStorage.redirectPath,
      staySignedIn: true,
      fetchUser: false,
    });
  },*/
};
